import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { ExtensionDetailSaveEvent } from '../../extension-details/models/extension-detail-form-submit-event';

export const addExtension = createAction('[Add Extension] Add Extension');

export const createExtension = createAction(
   '[Create Extension] Create Extension',
   props<{ extensionSave: ExtensionDetailSaveEvent; continuous?: boolean }>()
);

export const createExtensionSuccess = createAction(
   '[API] Create Extension Success',
   props<{ extensionId: number; extensionNumber: number; continuous?: boolean }>()
);

export const createExtensionFailure = createAction('[API] Create Extension Failure', props<SingleGraphError>());
